import { render, staticRenderFns } from "./LogSourceSettings.vue?vue&type=template&id=5847404a"
import script from "./LogSourceSettings.vue?vue&type=script&lang=js"
export * from "./LogSourceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports